export const DEFAULT_VALIDATION_MESSAGE = 'This field is required.';
